/**
 * Check if a menu item should be rendered based on its feature flag
 * @param {Object} item - Menu item with optional ff property
 * @returns {boolean}
 */
export const shouldRenderMenuItem = (item) => {
  if (typeof item.ff === 'function') {
    return item.ff()
  }
  if (typeof item.ff === 'boolean') {
    return item.ff
  }
  return true
}

/**
 * Filter menu items to only include visible ones
 * @param {Array} items - Array of menu items
 * @returns {Array} - Filtered array of visible items
 */
export const filterVisibleMenuItems = (items) =>
  items.filter(shouldRenderMenuItem)

/**
 * Resolve href - handles both static strings and dynamic functions
 * @param {string|Function} href - Static href or function that receives token
 * @param {string} token - JWT token for dynamic URLs
 * @returns {string}
 */
export const resolveHref = (href, token) => {
  if (typeof href === 'function') {
    return href(token)
  }
  return href
}
